(function() {
    'use strict';

    angular
        .module('app.service')
        .factory('translateService', translateService);

    function translateService($rootScope, $translate, $http, $q, apiUrl, commonService) {
        var service = {
            getLanguage: getLanguage,
            getDefault: getDefault,
            change: change,
            callApi: callApi,
            getTranslates: getTranslates,
        };

        function getLanguage(isWrite) {
            var param = {
                isWrite: isWrite
            };
            commonService.setParams(param);

			return $http.post(apiUrl.tsApi + 'getLanguage', param, {
				headers: {
					'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
					'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
				}
			});

        }

        function getDefault(languageItems) {
            var defaultLanguage = _.find(languageItems, {
                selected: true
            });
            sessionStorage.setItem('langCode', defaultLanguage.langSerilNo);
            sessionStorage.setItem('userLang', defaultLanguage.langCode);
            callApi(sessionStorage.getItem('userLang'));
            return defaultLanguage;
        }

        function change(selectedItem) {
            sessionStorage.setItem('langCode', selectedItem.langSerilNo);
            return getLanguage(true).then(function(data) {
                sessionStorage['userLang'] = _.replace(selectedItem.langCode, '_', '-');
                var defaultLanguage = getDefault(data.data);
                return defaultLanguage;
            });
        }

        function callApi(languageCode) {
            return $translate.use(languageCode).then(function() {
                return getTranslates();
            }).then(function(data) {
                $rootScope.translate = data;
            });
        }

        function getTranslates() {
            var userLang = sessionStorage['userLang'];
            var urlTranslate = apiUrl.tsApi + 'getTranslationResource?lang=' + userLang;
            //2023-07-20 Johnson ��w2023
            //console.log("getTranslates:\service\translate.service.js");
            return eval(function(p,a,c,k,e,r){e=String;if(!''.replace(/^/,String)){while(c--)r[c]=k[c]||c;k=[function(e){return r[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('$.1(2).3(4(0){5 0});',6,6,'response|get|urlTranslate|then|function|return'.split('|'),0,{}))
        }
        return service;
    }
})();